import { CircularProgressbar } from "react-circular-progressbar";
import Icon from "components/Elements/Icon/Icon";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import { MailDataI } from "models/models";
import { getDaysLeft } from "utils/getDaysLeft";
import { useContent } from "contexts/contentContext/contentContext";
import { useTransofrmedDate } from "utils/dateViewTransformer";
import { getJFormStatus, getMailStatusTooltipTextValue } from "../helpers";

interface StatusElementI {
  data: MailDataI;
}

const StatusElement = ({ data }: StatusElementI) => {
  const { getTextByKey } = useContent();
  const jFormStatus = getJFormStatus(
    data.mailStatus,
    data.isEmbedManuallyDeleted,
    data?.isSaved,
    data.downloadsQuantity,
    data.expirationDate
  );
  const status = data.isJForm ? jFormStatus : data.mailStatus;
  const { days: daysLeft, hours: hoursLeft } = getDaysLeft(data.expirationDate);

  const enumObj = {
    saved: <Icon name="saved" />,
    unactive: <Icon name="saved" />,
    active: data.isJForm ? (
      <div className="circular-progress-jform">
        {!data.expirationDate && (
          <Icon name="newInbox/Statuses/watch" iconClass="watch-jform" />
        )}
        <CircularProgressbar
          value={(daysLeft! / 7) * 100}
          text={data.expirationDate ? daysLeft + "d" : ""}
          className="orange"
          counterClockwise={true}
        />
      </div>
    ) : data.expirationDate ? (
      <CircularProgressbar
        value={(daysLeft! / 7) * 100}
        text={daysLeft + "d"}
        className="orange"
        counterClockwise={true}
      />
    ) : (
      <Icon name="rec_saved" ext="png" />
    ),
    removed: <Icon name="archived" gray />,
    created: <Icon name="newInbox/Statuses/created" />,
    deleting: <Icon name="newInbox/Statuses/clock" alt="" />,
    uploading: <Icon name="newInbox/Statuses/spinner" alt="" />,
    pendingRemoved: <Icon name="hourglass" red />,
    pendingDownload: <Icon name="pending_download" ext="png" />,
    error: <Icon name="warning" red />,
    downloaded: <Icon name="downloaded" green />,
  } as const;

  const { returnTime, returnDate } = useTransofrmedDate({
    date: data.expirationDate,
  });

  const tooltipTextValue = getMailStatusTooltipTextValue(
    status,
    data.isJForm,
    data.expirationDate,
    hoursLeft,
    daysLeft,
    data.codes,
    returnDate,
    returnTime,
    data.autoRemove,
    getTextByKey
  );

  return (
    <div
      className={
        `mail-status-element-wrapper mail-status-element-wrapper-${status}` +
        (status === "active" ? `-orange` : "")
      }
    >
      {/*@ts-ignore*/}
      <Tooltip id={status + data.id} tooltipText={tooltipTextValue} end>
        <div className="mail-status-element">
          {enumObj[status as keyof typeof enumObj] || enumObj.error}
        </div>
        <span className="mail-status-element-description">
          {getTextByKey(`${status}-mail-status-inbox`)}
        </span>
      </Tooltip>
    </div>
  );
};

export default StatusElement;
